import { getTokenAndFetchHeaders } from "../utils";

const api = process.env['REACT_APP_BACKEND_URL'];
const apiKey = process.env.REACT_APP_BACKEND_KEY ? process.env.REACT_APP_BACKEND_KEY : '';
export const getFiles = async (getToken: any, args: any, endpoint = '/file', folder = '') => {
  const headers = await getTokenAndFetchHeaders(getToken, args, apiKey);
  const res = await fetch(`${api}${endpoint}?folder=${folder}`, {
    headers,
    method: 'GET',
  });
  if (!res.ok) {
    throw new Error("Failed to load files.");
  }
  return res.json();
};

export const deleteFile = async (fileName: string, getToken: any, args: any, endpoint = '/file') => {
  const fileNameParam = encodeURIComponent(fileName);
  const headers = await getTokenAndFetchHeaders(getToken, args, apiKey);
  const res = await fetch(`${api}${endpoint}?fileId=${fileNameParam}`, {
    method: 'DELETE',
    headers,
  });
  if (!res.ok) {
    throw new Error('Failed to delete file.');
  }
  return res.json();
};
export const createFile = async (objectToUpload: FormData, getToken: any, args: any, endpoint: string) => {
  const headers = await getTokenAndFetchHeaders(getToken, args, apiKey, null);
  const res = await fetch(`${api}${endpoint}`, {
    method: 'POST',
    headers,
    body: objectToUpload,
  });
  if (!res.ok) {
    throw new Error('Upload attempt failed.');
  }
  return res.json();
}